module.exports = __webpack_public_path__ + "media/images/menu/planetary_nebulae-5bf36e0795b35825bae5f63a866d5e92.jpg";